// utils/detectFirmIdsFromTitle.ts

const firmMappings = [
  { keyword: "FXIFY", firmId: "fxify" },
  { keyword: "CTI", firmId: "cti" },
  { keyword: "The Trading Pit", firmId: "ttp" },
  { keyword: "E8", firmId: "e8" },
  { keyword: "Alpha Capital", firmId: "alpha-capital" },
  { keyword: "For Traders", firmId: "for-traders" },
  { keyword: "Seacrest", firmId: "seacrest-funded" },
  { keyword: "Trading Plus", firmId: "tradingplus" },
  { keyword: "WeMasterTrade", firmId: "wmt" }
];

/**
 * Detect firm IDs based on blog title.
 * Returns up to 2 firmIds depending on matches.
 */
export function detectFirmIdsFromTitle(title: string): string[] {
  if (!title) return [];

  const lowerTitle = title.toLowerCase();
  const matchedFirmIds: string[] = [];

  for (const { keyword, firmId } of firmMappings) {
    if (lowerTitle.includes(keyword.toLowerCase())) {
      matchedFirmIds.push(firmId);
    }
  }

  return matchedFirmIds;
}

/**
 * Get a random firmId that is not in the exclude list.
 */
export function getRandomFirmId(exclude: string[] = []): string {
  const availableFirms = firmMappings
    .map(f => f.firmId)
    .filter(firmId => !exclude.includes(firmId));

  if (availableFirms.length === 0) {
    return "fxify"; // fallback
  }

  const randomIndex = Math.floor(Math.random() * availableFirms.length);
  return availableFirms[randomIndex];
}
